module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/paperwalletemptyFgBlue.520e5e65e92a2c53e12a8af3c46c5153.svg";